/**
 * eventually this file will live somewhere more common to all applications
 */
import { storeSet } from '@cmd/ui-utilities';
const { reducer: organizationReducer, selector: organizationSelector, urlUpdater: organizationUrlUpdater, } = storeSet('orgId', undefined);
export { organizationReducer, organizationSelector, organizationUrlUpdater };
export default { organizationReducer, organizationSelector, organizationUrlUpdater };
